import { slugs } from '@/constants/slugs'

export const GUILD_AGE_RECOMMENDATIONS = {
  [slugs.sketch]: {
    description:
      'Contains scary chalk and crayon monsters and music, 1 sh*t, 5 h*ll, 2 dumb*ss, other mildly crude language.',
  },
  [slugs.senior]: {
    description: 'Contains discussion of drugs, depictions of violence, 1 a*s, 1 d*mmit, other mildly crude language.',
  },
  [slugs.truthAndTreason]: {
    description: 'Contains depictions of torture and violence, 1 bl*ody, other mildly crude language.',
  },
  [slugs.david]: {
    description: 'Contains depictions of cartoon violence and some scenes with bone-clad warriors.',
  },
  [slugs.soloMio]: {
    description: 'Contains frequent alcohol use, some smoking, mature romantic themes, and 1 use of h*ll.',
  },
} as const
